export default __webpack_public_path__ + "static/media/ssl-secure.dd09a1ee.svg";